const HU = {
  associationIncorporated: [
    "egyesülés"
  ],
  partnershipIncorporated: [
    "limited liability partnership (LP)"
  ],
  partnershipUnincorporated: [
    "betéti társaság (Bt.)",
    "közkereseti társaság (Kkt.)"
  ]
};
export {
  HU as default
};
